// extracted by mini-css-extract-plugin
export var hero = "hero-sideprojects-module--hero--vJ9me";
export var heroName = "hero-sideprojects-module--heroName--2goTW";